export const styles = {
	createMemberTypesPaper: {
		position: 'relative',
		padding: '16px'
	},
	addMemberTypeButton: {
		float: 'right',
		maxWidth: '250px',
		width: '100%',
		marginTop: '10px'
	},
	overlay: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		width: '100%',
		height: '100%',
		background: '#e3dfdf82',
		opacity: 0.5
	}
};
